/// <reference path="../_all.ts" />

module library {
  'use strict';
  
  OpenDocumentDetailDirective.$inject = ['libraryService'];
  export function OpenDocumentDetailDirective(libraryService: library.ILibraryService): ng.IDirective {
    return {
      restrict: 'A',
      scope: {
        revId : '=',
      },
      link: function (scope: IOpenDocumentDetailDirectiveScope, element: ng.IAugmentedJQuery, attr: ng.IAttributes) {
        element.on('click', function () {
          libraryService.openDialog(attr.openDocumentDetail, scope, null);
        }); 
      }
    }
  }
} 
